import { render } from "./DijiaNumberPool.vue?vue&type=template&id=488ac6b1&scoped=true"
import script from "./DijiaNumberPool.vue?vue&type=script&lang=js"
export * from "./DijiaNumberPool.vue?vue&type=script&lang=js"

import "./DijiaNumberPool.vue?vue&type=style&index=0&id=488ac6b1&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-488ac6b1"

export default script